// PendingOrderProvider.js
import React, { useState, useEffect, createContext } from 'react';
import { apiFetch } from '../../apiClient'; // adjust the path as needed

export const PendingOrderContext = createContext({
    hasPendingOrder: false,
    refreshPendingOrder: () => { },
});

const PendingOrderProvider = ({ children }) => {
    const [hasPendingOrder, setHasPendingOrder] = useState(false);

    const refreshPendingOrder = async () => {
        try {
            const response = await apiFetch('/api/orders/my-pending/');
            if (response.ok) {
                const data = await response.json();
                setHasPendingOrder(!!data.order);
            } else {
                setHasPendingOrder(false);
            }
        } catch (error) {
            console.error('Error refreshing pending order:', error);
            setHasPendingOrder(false);
        }
    };

    useEffect(() => {
        refreshPendingOrder();
    }, []);

    return (
        <PendingOrderContext.Provider value={{ hasPendingOrder, refreshPendingOrder }}>
            {children}
        </PendingOrderContext.Provider>
    );
};

export default PendingOrderProvider;